import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Typography,
  Box
} from '@mui/material';
import { Delete as DeleteIcon, WarningAmberRounded as WarningIcon } from '@mui/icons-material';

export function ConfirmationDialog({open, handleOk, title, message, handleClose, buttonTitle }) {

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: { borderRadius: 3, p: 2 }
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1 }}>
          <WarningIcon color="warning" fontSize="large" />
          <DialogTitle sx={{ m: 0, p: 0 }}>{title}</DialogTitle>
        </Box>

        <DialogContent sx={{ px: 0 }}>
          <DialogContentText sx={{ fontSize: 15 }}>
           {message}
          </DialogContentText>
        </DialogContent>

        <DialogActions sx={{ px: 0, pt: 3 }}>
          <Button onClick={handleClose} sx={{ borderRadius: 2 }}>
            Cancel
          </Button>
          <Button
            onClick={() => handleOk()}
            variant="contained"
            color="error"
            sx={{ borderRadius: 2 }}
          >
            {buttonTitle ? buttonTitle : 'OK'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

